import React from 'react';
import PropTypes from 'prop-types';

import { getClass } from '../../../utils/component-helpers';
import Icon from '../icon';

import './dropdown.scss';

const DropdownToggle = props => {
  const { label, alternateIcon, iconSize, isOpen, onClick, styleType, errors } = props;

  return (
    <div
      className={getClass('toggle-container', { active: isOpen, alternateIcon: !!alternateIcon })}
      onClick={onClick}
    >
      <div className={getClass('dropdown', styleType, { invalid: errors.length })}>
        <span className="label">{label}</span>
        {/* Allow use of variable icon size and alternate icons to up/down arrow */}
        <Icon size={iconSize} iconName={alternateIcon || (isOpen ? 'chevronUp' : 'chevronDown')} />
      </div>
      <div className="error-messages">
        {errors.map(message => (
          <div key={message}>{message}</div>
        ))}
      </div>
    </div>
  );
};

DropdownToggle.propTypes = {
  label: PropTypes.string.isRequired,
  alternateIcon: PropTypes.string,
  iconSize: PropTypes.number,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  styleType: PropTypes.oneOf([null, 'bordered']),
  inputLabel: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
};

DropdownToggle.defaultProps = {
  alternateIcon: null,
  iconSize: 12,
  onClick: () => {},
  isOpen: false,
  styleType: null,
  inputLabel: '',
  errors: [],
};

export default DropdownToggle;
